// extracted by mini-css-extract-plugin
export var chevron = "_bv-2";
export var dropdownItems = "_bv-0";
export var item = "_bv-1";